import { Routes } from '@angular/router';
import { SurveyPageComponent } from './features/survey/pages/survey-page/survey-page.component';
import { SurveyLandingComponent } from './features/survey/pages/survey-landing-page/survey-landing-page.component';

export const routes: Routes = [
  {
    path: 'secret-demo',
    component: SurveyPageComponent,
    title: 'IMT Survey | Demo',
    data: { demo: true },
  },
  { path: 'survey/:token', component: SurveyPageComponent, title: 'IMT Survey | Questionnaire' },
  { path: '', component: SurveyLandingComponent, title: 'IMT Survey | Welcome' },
  { path: '**', component: SurveyLandingComponent, title: 'IMT Survey | Welcome' },
];
